import { AlertDialog, Button, Flex } from '@radix-ui/themes'
import { PromotionCampaign } from '@Generated/back-office-client/src'

type DeleteConfirmationDialogProps = {
  campaign: PromotionCampaign | null
  isDeleting: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const DeleteConfirmationDialog = ({
  campaign,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteConfirmationDialogProps) => {
  return (
    <AlertDialog.Root open={!!campaign} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialog.Content>
        <AlertDialog.Title>Delete Campaign</AlertDialog.Title>
        <AlertDialog.Description>
          Are you sure you want to delete &ldquo;{campaign?.name}&rdquo;? This action cannot be
          undone.
        </AlertDialog.Description>
        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="outline">Cancel</Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button color="red" onClick={onConfirm} disabled={isDeleting}>
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )
}
